import { render } from "./GeneralTerms.vue?vue&type=template&id=2083d84a"
import script from "./GeneralTerms.vue?vue&type=script&lang=js"
export * from "./GeneralTerms.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__